<template>
  <div id="wrapper">
    <Topbar v-show="!blockedScreen" :is-menu-opened="showMobileMenu" />
    <SideBar v-show="!blockedScreen" v-if="user" />
    <div class="content-page" :class="{ 'blocked-screen': blockedScreen }">
      <div class="content" :style="{ marginTop: '25px' }">
        <div class="container-fluid"><router-view /></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Topbar: () => import('./Partials/Topbar.vue'),
    SideBar: () => import('./Partials/SideBar.vue')
  },
  data() {
    return {
      showMobileMenu: false
    }
  },
  computed: {
    blockedScreen() { return this.$store.getters['auth/blockedScreen'] },
    user() { return this.$store.getters['auth/user'] }
  },
  methods: {
    toggleMenu() { this.showMobileMenu = !this.showMobileMenu }
  }
}
</script>